import {importProvidersFrom} from '@angular/core';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {provideHttpClient, withInterceptorsFromDi,} from '@angular/common/http';

import {environment, prepareApp} from './environments/environment';
import {routing} from './app/app.routes';
import {AuthConfigModule} from './app/auth-config.module';
import {AppComponent} from './app/app.component';
import {APP_BASE_HREF, PlatformLocation} from "@angular/common";

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}

prepareApp().then(async () => {
    const response = await fetch('/apis/configuration/authentication', {
        headers: {'Content-Type': 'application/json'},
    });

    environment.authenticationConfiguration =
        response.status === 200 ? await JSON.parse(await response.text()) : null;

    bootstrapApplication(AppComponent, {
        providers: [
            {
                provide: APP_BASE_HREF,
                useFactory: getBaseHref,
                deps: [PlatformLocation]
            },
            importProvidersFrom(BrowserModule, routing, AuthConfigModule),
            provideHttpClient(withInterceptorsFromDi()),
        ],
    }).catch((err) => console.error(err));
});
